import * as yup from "yup";

export const editRewardSchemas = yup
  .object({
    planId: yup.string().required("Plan id is required"),
    passcode: yup.string().required("Passcode is required"),
    name: yup.string().required("Reward name is required"),
    validity: yup.string().required("validity required"),
    rewardExpiryDate: yup.string().when("validity", (type, schema) => {
      return type == "expiry"
        ? schema.required("Expiration date is required")
        : schema.notRequired();
    }),
    days: yup.string().when("validity", (type, schema) => {
      return type == "days"
        ? schema.required("Days are required")
        : schema.notRequired();
    }),
    rewardDetails: yup
      .array()
      .of(
        yup.object().shape({
          id: yup.number(),
          position: yup.number(),
          startPosition: yup
            .number()
            .required("Position is required")
            .positive("Position must be positive")
            .typeError("Position is required"),
          redeemPasscode: yup.string(),
          description: yup.string().required("Description is required"),
        })
      )
      .min(1, "At least one reward detail is required"),
  })
  .required();
